import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import RangeSliderBorderRadius from "../../../UI/RangeSliderBorderRadius";
import {
  AlignHorizontalJustifyStart,
  AlignHorizontalJustifyEnd,
  AlignVerticalJustifyStart,
  AlignVerticalJustifyEnd,
  AlignHorizontalSpaceBetween,
  AlignHorizontalSpaceAround,
 
  AlignHorizontalJustifyCenter,
  AlignHorizontalDistributeCenter,
  AlignVerticalJustifyCenter,
  AlignVerticalDistributeCenter,
  AlignVerticalSpaceBetween,
  Square,
  Squircle,
  Circle,
} from "lucide-react";
import {
  AlignVerticalSpaceAround,
  AlignVerticalJustifyStretch,
} from "lucide-react";
const ItemAspectRatioUI =  ({ itemsArray, callbackItemValue, objectValue,objectName,displayName ,}) => {
  const [items ,setItems] =useState(itemsArray);
const [resolution, setPxPercent] = useState(objectValue?objectValue?.resolution:'px');
const [cornerType, setCornerType] = useState('');
 const flexDirectionIcons = {
  "row": <AlignHorizontalJustifyStart size={20} color="#666" />,
  "row-reverse": <AlignHorizontalJustifyEnd size={20} color="#666" />,
  "column": <AlignVerticalJustifyStart size={20} color="#666" />,
  "column-reverse": <AlignVerticalJustifyEnd size={20} color="#666" />
};
const justifyContentIcons = {
  "flex-start": <AlignHorizontalJustifyStart size={20} color="#666" />,
  "flex-end": <AlignHorizontalJustifyEnd size={20} color="#666" />,
  "center": <AlignHorizontalJustifyCenter size={20} color="#666" />,
  "space-between": <AlignHorizontalSpaceBetween size={20} color="#666" />,
  "space-around": <AlignHorizontalSpaceAround size={20} color="#666" />,
  "space-evenly": <AlignHorizontalDistributeCenter size={20} color="#666" />
};
const alignItemsIcons = {
  "flex-start": <AlignVerticalJustifyStart size={20} color="#666" />,
  "flex-end": <AlignVerticalJustifyEnd size={20} color="#666" />,
  "center": <AlignVerticalJustifyCenter size={20} color="#666" />,
  "stretch": <AlignVerticalSpaceBetween size={20} color="#666" />,  // use AlignVerticalJustifyStretch if available
  "baseline": <AlignVerticalDistributeCenter size={20} color="#666" /> // fallback to a generic if this isn't available
};
const alignContentIcons = {
  "flex-start": <AlignVerticalJustifyStart size={20} color="#666" />,
  "flex-end": <AlignVerticalJustifyEnd size={20} color="#666" />,
  "center": <AlignVerticalJustifyCenter size={20} color="#666" />,
  "stretch": <AlignVerticalSpaceBetween size={20} color="#666" />,
  "space-between": <AlignVerticalDistributeCenter size={20} color="#666" />,
  "space-around": <AlignVerticalSpaceAround size={20} color="#666" />
};
     const dispatch = useDispatch();  
     const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
            {
              
              dispatch({type: "CURSOR",payload:true  });
          
              dispatch({type: "CURSORTEXT",payload:CursorText})
              dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
              dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
            }
             
            const handleMouseLeave = () => {
              
              dispatch({type: "CURSOR",payload:false})
          
              dispatch({type: "CURSORTEXT",payload:""})
          
              dispatch({type: "CURSORTEXTBG",payload:""})
              dispatch({type: "CURSORTEXTCOLOR",payload:""})
            
          
          }
 const [itemValue, setItemValue] = useState(objectValue);

 return(<>


                                                    <div  style={{display:"flex",justifyContent:"space-around"}}>
                                               <h4>{displayName}  </h4>
           <div style={{height:"110px"}}> 
            <div class="input-card-outer"style={{
                 
                  transition: 'transform 3s ease, opacity 3s ease',
                borderRadius:"25px",padding:"0px"}} >
                                          
                                          <div  style={{display:"flex",justifyContent:"space-around"}}>
                                                  <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                             <div style={{display:"flex",justifyContent:"space-between"}} >
                                              
                                             2/1
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={itemValue=="2/1"?"yes":""}
                   className="input-textbox"  value={"2/1"}  name={objectName}  
                   onClick={e=>{setItemValue("2/1");callbackItemValue("2/1");
                   }}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                        <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                            <div style={{display:"flex",justifyContent:"space-between"}} >
                                            
                                            1/1                        
                                             </div> 
                              <input type="radio" title="Color Theme"   checked={itemValue=="1/1"?"yes":""}
                   className="input-textbox"  value="1/1"  name={objectName}  
                   onChange={e=>{setItemValue("1/1");callbackItemValue("1/1");}}/>
                        <span class={"boxCardBorder-two"}></span> </label> 
                          <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                            <div style={{display:"flex",justifyContent:"space-between"}} >
                                            3/4
                                                                     
                                             </div> 
                              <input type="radio" title="Color Theme"   checked={itemValue=="3/4"?"yes":""}
                   className="input-textbox"  value="3/4"  name={objectName}  
                   onChange={e=>{setItemValue("3/4");callbackItemValue("3/4");}}/>
                        <span class={"boxCardBorder-two"}></span> </label> 
                          <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                            <div style={{display:"flex",justifyContent:"space-between"}} >
                                             4/3                        
                                                                     
                                             </div> 
                              <input type="radio" title="Color Theme"   checked={itemValue=="4/3"?"yes":""}
                   className="input-textbox"  value="4/3"  name={objectName}  
                   onChange={e=>{setItemValue("4/3");callbackItemValue("4/3")}}/>
                        <span class={"boxCardBorder-two"}></span> </label> 
                        </div>  </div>
                         <div class="input-card-outer"style={{
                 
                  transition: 'transform 3s ease, opacity 3s ease',
                borderRadius:"25px",padding:"0px"}} >
                                          
                                          <div  style={{display:"flex",justifyContent:"space-around"}}>
                                                  <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                             <div style={{display:"flex",justifyContent:"space-between"}} >
                                              
                                             4/1
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={itemValue=="4/1"?"yes":""}
                   className="input-textbox"  value={"4/1"}  name={objectName}  
                   onClick={e=>{setItemValue("4/1");callbackItemValue("4/1");
                  }}/>
                        <span class={"boxCardBorder-two"}></span> </label> <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                             <div style={{display:"flex",justifyContent:"space-between"}} >
                                              
                                             8/3
                                                                      </div>  
                              <input type="radio" title="Set As Years"   checked={itemValue=="8/3"?"yes":""}
                   className="input-textbox"  value={"8/3"}  name={objectName}  
                   onClick={e=>{setItemValue("8/3");callbackItemValue("8/3");
                  }}/>
                        <span class={"boxCardBorder-two"}></span> </label>
                        
                          <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                            <div style={{display:"flex",justifyContent:"space-between"}} >
                                            9/16
                                                                     
                                             </div> 
                              <input type="radio" title="Color Theme"   checked={itemValue=="9/16"?"yes":""}
                   className="input-textbox"  value="9/16"  name={objectName}  
                   onChange={e=>{setItemValue("9/16");callbackItemValue("9/16");}}/>
                        <span class={"boxCardBorder-two"}></span> </label> 
                          <label onMouseEnter={
                                             ()=>handleMouseEnter("#fff","#333","")}
                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                            <div style={{display:"flex",justifyContent:"space-between"}} >
                                             16/9                      
                                                                     
                                             </div> 
                              <input type="radio" title="Color Theme"   checked={itemValue=="16/9"?"yes":""}
                   className="input-textbox"  value="16/9"  name={objectName}  
                   onChange={e=>{setItemValue("16/9");callbackItemValue("16/9");}}/>
                        <span class={"boxCardBorder-two"}></span> </label> 
                        </div>  </div>
                        </div> </div>
                                 </>)

    } 
    export default ItemAspectRatioUI;

                     

